export default {
  __setToken(token) {
    const preparedToken = `Bearer ${token}`

    localStorage.setItem('token', preparedToken)
    Echo.connector.options.auth.headers['Authorization'] = preparedToken
    axios.defaults.headers.common['Authorization'] = preparedToken
  },
}
